import dynamic from "next/dynamic";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import LogoMarquee from "@/components/LogoMarquee";
import IndustryWins from "@/components/IndustryWins";
import Footer from "@/components/Footer";

// Below-fold sections — lazy loaded for faster initial paint
const Testimonials = dynamic(() => import("@/components/Testimonials"));
const GlobalReach = dynamic(() => import("@/components/GlobalReach"));
const AIPowered = dynamic(() => import("@/components/AIPowered"));
const Services = dynamic(() => import("@/components/Services"));
const WhyChooseUs = dynamic(() => import("@/components/WhyChooseUs"));
const Pricing = dynamic(() => import("@/components/Pricing"));
const Bonuses = dynamic(() => import("@/components/Bonuses"));
const ComparisonTable = dynamic(() => import("@/components/ComparisonTable"));
const FAQ = dynamic(() => import("@/components/FAQ"));
const BookCall = dynamic(() => import("@/components/BookCall"));
const ContactForm = dynamic(() => import("@/components/ContactForm"));

export default function Home() {
  return (
    <>
      <SmoothScroll />
      <Navbar />
      <Hero />
      <LogoMarquee />
      <IndustryWins />
      <Testimonials />
      <GlobalReach />
      <AIPowered />
      <Services />
      <WhyChooseUs />
      <Pricing />
      <Bonuses />
      <ComparisonTable />
      <FAQ />
      <BookCall />
      <ContactForm />
      <Footer />
    </>
  );
}
